<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <t-input v-model="form.operatorId" hidden/>

      <t-input label="Operador vinculado a usuário da plataforma?"
               help="Deixe como Não somente se desejar cadastrar um operador que não possua acesso, entretando você poderá inserir Operadores de forma rápida através do cadastro de usuários, onde é possível inclusive habilitar acesso somente via código."
               v-model="yesOrNotLinkUser" :options="yesOrNotOptions"
               radio/>

      <div v-show="onYesLinkUser">

        <t-input v-model="form.userId" :options="usersOptions" :add-error="error.userId"
                 label="Usuário da plataforma" :required="onYesLinkUser" select/>

      </div>


      <div v-show="!onYesLinkUser">

        <t-input v-model="form.name"  :add-error="error.name" label="Nome" :required="!onYesLinkUser"/>

        <t-input select :options="groupUserOptions" v-model="form.groupUserId" label="Grupo de Usuário"
                 :required="!onYesLinkUser"/>

      </div>

      <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

      <t-input-status v-model="form.status"/>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import userService from "@/services/modules/setting/User.service";
import groupUserService from "@/services/modules/admin/GroupUser.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'OperatorForm',

  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "operatorId",
      form: {
        operatorId: 0,
        groupUserId: 0,
        userId: 0,
        name: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        userId: "",
        name: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      yesOrNotLinkUser: "N", //Valor padrão não possui vinculo com usuário
      usersOptions: [],
      groupUserOptions: [],


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    async onSubmit() {

      await this.setSendingDefault()


    },
    mountedPrepare() {


    },
    async mountedContinued() {

      await userService.selectList("").then((list) => {
        this.usersOptions = list
      }).catch(error => this.responseError(error))


      await groupUserService.selectList("").then((list) => {
        this.groupUserOptions = list
      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true

      if (this.form.userId > 0) {
        this.yesOrNotLinkUser = "Y"
      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },
  computed: {
    onYesLinkUser() {
      return this.yesOrNotLinkUser === 'Y'
    }
  }

}
</script>
